import React from 'react';

export default function AdminSectionHeader({ title, subtitle }) {
  return (
    <div className="admin-section-header">
      <h2>{title}</h2>
      {subtitle && <p className="admin-section-subtitle">{subtitle}</p>}
    </div>
  );
}